import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokhatushyamcab() {



    const cardData = {

keyword: "Mumbai to Khatu Shyam Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Khatu Shyam Cab services for pilgrimage tours, family trips, religious travel, group journeys, and one-way or round-trip travel. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe long-distance highway travel, we ensure a comfortable, convenient, and hassle-free journey from Mumbai to Khatu Shyam Ji and other major destinations in Rajasthan.",

topPlaces: [
    {
        title: "Khatu Shyam Ji Temple",
        description:
            "Khatu Shyam Ji Temple is one of the most revered pilgrimage destinations in Rajasthan and attracts millions of devotees every year. Dedicated to Barbarik, the grandson of Bhima from the Mahabharata, the temple is known for its spiritual significance, grand celebrations, and powerful religious atmosphere. Devotees from across India visit the temple seeking blessings, peace, prosperity, and fulfillment of wishes."
    },
    {
        title: "Shyam Kund",
        description:
            "Shyam Kund is a sacred pond located near the Khatu Shyam Ji Temple and holds immense religious importance among devotees. It is believed that taking a holy dip in the kund before visiting the temple brings spiritual purification and blessings. Pilgrims often include this sacred site as an essential part of their Khatu Shyam pilgrimage experience."
    },
    {
        title: "Jaipur",
        description:
            "Jaipur, the capital city of Rajasthan, is a major destination often included in Khatu Shyam tours. Known as the Pink City, Jaipur offers iconic attractions such as Hawa Mahal, Amer Fort, City Palace, and Jantar Mantar. Travelers enjoy a combination of spiritual travel and cultural exploration while visiting Rajasthan."
    },
    {
        title: "Salasar Balaji Temple",
        description:
            "Salasar Balaji Temple is one of Rajasthan's most famous Hanuman temples and is frequently visited along with Khatu Shyam Ji. The temple attracts devotees throughout the year and is known for its strong spiritual significance, grand fairs, and religious atmosphere. Many pilgrims combine both destinations during their religious journey."
    },
    {
        title: "Jeen Mata Temple",
        description:
            "Jeen Mata Temple is a highly revered Shakti temple located in the Sikar district of Rajasthan. Surrounded by scenic hills, the temple attracts thousands of devotees seeking blessings from Goddess Jeen Mata. It is commonly included in pilgrimage itineraries along with Khatu Shyam Ji and Salasar Balaji."
    },
    {
        title: "Sikar",
        description:
            "Sikar is an important city in the Shekhawati region and serves as a gateway to Khatu Shyam Ji. The city is known for its heritage architecture, colorful havelis, temples, and rich Rajasthani culture. Visitors often explore Sikar while traveling to nearby pilgrimage destinations."
    },
    {
        title: "Rani Sati Temple",
        description:
            "Located in Jhunjhunu, Rani Sati Temple is one of the most prominent religious sites in Rajasthan. The temple is famous for its beautiful marble construction, spiritual significance, and unique architecture. Pilgrims traveling through the Shekhawati region often include this destination in their itinerary."
    },
    {
        title: "Amer Fort",
        description:
            "Amer Fort is one of Rajasthan's most iconic historical monuments and a UNESCO-recognized attraction near Jaipur. Known for its magnificent architecture, royal courtyards, artistic carvings, and hilltop location, the fort provides visitors with a memorable glimpse into Rajasthan's royal heritage."
    },
    {
        title: "Ajmer Sharif & Pushkar",
        description:
            "Ajmer Sharif Dargah and Pushkar are two of Rajasthan's most important spiritual destinations. Ajmer is known for the revered Sufi shrine of Khwaja Moinuddin Chishti, while Pushkar is famous for the Brahma Temple and sacred lake. Many travelers extend their Rajasthan pilgrimage by visiting both locations."
    },
    {
        title: "Bikaner",
        description:
            "Bikaner is a historic city known for magnificent forts, royal palaces, traditional markets, and authentic Rajasthani culture. Visitors traveling from Mumbai to Rajasthan often explore Bikaner for its heritage attractions, famous cuisine, and unique desert landscapes, making it a valuable addition to longer pilgrimage and sightseeing tours."
    }
],



services: [
{
name: "Mumbai to Khatu Shyam Cab Service",
description: "Mumbai to Khatu Shyam Cab Service by 1Touch Cabs provides comfortable and reliable transportation for devotees traveling from Mumbai to the famous Khatu Shyam Ji Temple in Rajasthan. We offer Sedan, SUV, Innova, Innova Crysta, Ertiga, Kia Carens, and Tempo Traveller vehicles with experienced chauffeurs for long-distance journeys. Our service includes flexible pickup locations, comfortable highway travel, luggage assistance, and customized travel schedules. Whether you are planning a family pilgrimage, group yatra, or personal spiritual journey, we ensure safe, convenient, and hassle-free travel with transparent pricing and 24x7 booking support."
},
{
name: "Khatu Shyam Cab Service from Mumbai",
description: "Khatu Shyam Cab Service from Mumbai offers dedicated pilgrimage transportation for devotees visiting Khatu Shyam Ji. 1Touch Cabs provides clean vehicles, professional drivers, and comfortable long-distance travel arrangements. We ensure a smooth and memorable spiritual journey with reliable service throughout the trip."
},
{
name: "Mumbai to Khatu Shyam Cab Package",
description: "Mumbai to Khatu Shyam Cab Package provides complete transportation solutions with flexible travel plans for individuals, families, and groups. 1Touch Cabs offers customized itineraries, comfortable vehicles, experienced chauffeurs, and affordable package options for Khatu Shyam Darshan."
},
{
name: "Mumbai to Khatu Shyamji Cab",
description: "Mumbai to Khatu Shyamji Cab service offers dependable road transportation for devotees traveling to Rajasthan. 1Touch Cabs provides spacious vehicles, professional chauffeurs, and comfortable travel experiences. We ensure safe and timely journeys for pilgrims and tourists alike."
},
{
name: "Mumbai to Khatu Shyam Mandir Taxi",
description: "Mumbai to Khatu Shyam Mandir Taxi service provides direct transportation to the sacred Khatu Shyam Temple. 1Touch Cabs offers reliable vehicles, courteous drivers, and convenient travel schedules. We ensure a comfortable pilgrimage experience from start to finish."
},
{
name: "Mumbai to Rajasthan Khatu Shyam Cab",
description: "Mumbai to Rajasthan Khatu Shyam Cab service offers long-distance transportation with modern vehicles and experienced chauffeurs. 1Touch Cabs provides safe highway travel, comfortable seating, and dependable support for devotees visiting Khatu Shyam Ji in Rajasthan."
},
{
name: "Mumbai to Sikar Cab Service",
description: "Mumbai to Sikar Cab Service provides reliable intercity transportation for pilgrims, tourists, and business travelers. 1Touch Cabs offers comfortable vehicles, affordable pricing, and professional chauffeur service. We ensure safe and convenient travel between Mumbai and Sikar."
},
{
name: "Mumbai to Khatu Shyam Darshan Cab",
description: "Mumbai to Khatu Shyam Darshan Cab service is specially designed for devotees planning a spiritual visit to Khatu Shyam Ji. 1Touch Cabs provides customized travel schedules, comfortable vehicles, and professional drivers to make your darshan journey peaceful and convenient."
},
{
name: "Mumbai to Khatu Shyam Road Trip Taxi",
description: "Mumbai to Khatu Shyam Road Trip Taxi service offers comfortable long-distance travel through well-maintained highways and scenic routes. 1Touch Cabs provides reliable vehicles, experienced chauffeurs, and flexible travel plans for families and groups."
},
{
name: "Mumbai to Khatu Shyam Long Distance Cab",
description: "Mumbai to Khatu Shyam Long Distance Cab service provides safe and convenient transportation for extended journeys. 1Touch Cabs offers spacious vehicles, professional drivers, and comfortable travel arrangements designed for long-distance road trips."
},
{
name: "Mumbai to Khatu Shyam Round Trip Cab",
description: "Mumbai to Khatu Shyam Round Trip Cab service offers complete return transportation with flexible travel schedules and affordable packages. 1Touch Cabs provides comfortable vehicles, experienced chauffeurs, and reliable support throughout the pilgrimage."
},
{
name: "Mumbai to Khatu Shyam Pickup and Drop",
description: "Mumbai to Khatu Shyam Pickup and Drop service provides door-to-door transportation for pilgrims and families. 1Touch Cabs offers convenient pickups, comfortable travel, and safe drop facilities to ensure a stress-free travel experience."
},
{
name: "Mumbai to Khatu Shyam AC Cab",
description: "Mumbai to Khatu Shyam AC Cab service offers air-conditioned transportation for comfortable travel throughout the journey. 1Touch Cabs provides clean vehicles, professional drivers, and reliable travel support to ensure maximum passenger comfort."
},
{
name: "Mumbai to Khatu Shyam SUV Cab",
description: "Mumbai to Khatu Shyam SUV Cab service provides spacious and comfortable transportation for families and groups. 1Touch Cabs offers premium SUV vehicles, experienced chauffeurs, and safe highway travel for long-distance journeys."
},
{
name: "Mumbai to Khatu Shyam Innova Crysta Cab",
description: "Mumbai to Khatu Shyam Innova Crysta Cab service offers premium travel comfort with spacious seating and ample luggage space. 1Touch Cabs provides luxury vehicles, professional chauffeurs, and smooth transportation for pilgrimage and family trips."
},
{
name: "Mumbai to Khatu Shyam Tempo Traveller",
description: "Mumbai to Khatu Shyam Tempo Traveller service is ideal for large groups, pilgrimage tours, and family gatherings. 1Touch Cabs offers well-maintained Tempo Travellers with comfortable seating and professional drivers for safe group transportation."
},
{
name: "Mumbai to Khatu Shyam Family Cab Service",
description: "Mumbai to Khatu Shyam Family Cab Service provides comfortable and secure transportation for families visiting Khatu Shyam Ji. 1Touch Cabs offers spacious vehicles, courteous chauffeurs, and flexible travel schedules to ensure a pleasant family journey."
},
{
name: "Mumbai to Khatu Shyam Corporate Cab",
description: "Mumbai to Khatu Shyam Corporate Cab service provides professional transportation solutions for business groups and corporate pilgrimage trips. 1Touch Cabs offers executive vehicles, experienced chauffeurs, and dependable travel management services."
},
{
name: "Mumbai to Khatu Shyamji Outstation Roundtrip Cabs",
description: "Mumbai to Khatu Shyamji Outstation Roundtrip Cabs service offers complete round-trip travel solutions with flexible itineraries and comfortable vehicles. 1Touch Cabs ensures reliable transportation, professional drivers, and excellent customer support throughout the journey."
},
{
name: "Mumbai to Rajasthan Cab",
description: "Mumbai to Rajasthan Cab service provides reliable long-distance transportation to cities and destinations across Rajasthan. 1Touch Cabs offers Sedan, SUV, Innova, and luxury vehicles with professional chauffeurs for safe and comfortable travel."
},
{
name: "Mumbai to Rajasthan Taxi",
description: "Mumbai to Rajasthan Taxi service offers convenient intercity transportation for tourists, families, pilgrims, and business travelers. 1Touch Cabs provides dependable vehicles, affordable pricing, and professional chauffeur service for every journey."
},
{
name: "Mumbai to Rajasthan Cab Service",
description: "Mumbai to Rajasthan Cab Service provides customized transportation solutions for leisure travel, pilgrimage tours, family vacations, and business trips. 1Touch Cabs ensures comfortable travel, flexible schedules, and reliable customer support."
},
{
name: "Mumbai to Rajasthan Taxi Booking",
description: "Mumbai to Rajasthan Taxi Booking service allows travelers to reserve transportation quickly and conveniently. 1Touch Cabs offers instant booking confirmation, multiple vehicle options, and transparent pricing for hassle-free travel planning."
},
{
name: "Cab from Mumbai to Rajasthan",
description: "Cab from Mumbai to Rajasthan service provides comfortable road transportation with professional chauffeurs and well-maintained vehicles. 1Touch Cabs ensures safe travel, affordable fares, and dependable service throughout the route."
},
{
name: "Taxi from Mumbai to Rajasthan",
description: "Taxi from Mumbai to Rajasthan service offers flexible travel solutions for long-distance journeys across Rajasthan. 1Touch Cabs provides experienced drivers, comfortable vehicles, and personalized travel arrangements to ensure a smooth and enjoyable trip."
}
],

tableData: [
["Mumbai to Khatu Shyam Cab Service","Khatu Shyam Cab Service from Mumbai"],
["Mumbai to Khatu Shyam Cab Package","Mumbai to Khatu Shyamji Cab"],
["Mumbai to Khatu Shyam Mandir Taxi","Mumbai to Rajasthan Khatu Shyam Cab"],
["Mumbai to Sikar Cab Service","Mumbai to Khatu Shyam Darshan Cab"],
["Mumbai to Khatu Shyam Road Trip Taxi","Mumbai to Khatu Shyam Long Distance Cab"],
["Mumbai to Khatu Shyam Round Trip Cab","Mumbai to Khatu Shyam Pickup and Drop"],
["Mumbai to Khatu Shyam AC Cab","Mumbai to Khatu Shyam SUV Cab"],
["Mumbai to Khatu Shyam Innova Crysta Cab","Mumbai to Khatu Shyam Tempo Traveller"],
["Mumbai to Khatu Shyam Family Cab Service","Mumbai to Khatu Shyam Corporate Cab"],
["Mumbai to Khatu Shyamji Outstation Roundtrip Cabs","Mumbai to Rajasthan Cab"],
["Mumbai to Rajasthan Taxi","Mumbai to Rajasthan Cab Service"],
["Mumbai to Rajasthan Taxi Booking","Cab from Mumbai to Rajasthan"],
["Taxi from Mumbai to Rajasthan","Mumbai to Khatu Shyam Darshan Cab"]
],











whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Khatu Shyam Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Khatu Shyam Cab services for devotees, families, pilgrimage groups, senior citizens, and spiritual travelers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Convenient Khatu Shyam Darshan Journey",
        WhyChoosedescription: "Travel comfortably from Mumbai to the famous Khatu Shyam Temple in Rajasthan with our customized pilgrimage cab services designed for a peaceful religious experience."
    },
    {
        WhyChooseheading: "Perfect for Religious and Spiritual Tours",
        WhyChoosedescription: "Our cab service is ideal for Khatu Shyam Darshan, Salasar Balaji visits, family pilgrimages, temple tours, and customized Rajasthan spiritual travel packages."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day pilgrimage package, or customized temple itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on long-distance Rajasthan routes and ensure safe, comfortable, and stress-free travel throughout the pilgrimage."
    },
    {
        WhyChooseheading: "Ideal for Families, Devotees, and Groups",
        WhyChoosedescription: "From individual devotees and families to large pilgrimage groups, we provide suitable vehicles for every religious travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do devotees book Mumbai to Khatu Shyam Cabs?",
        answer: "Khatu Shyam Temple is one of the most revered pilgrimage destinations in Rajasthan and attracts devotees seeking blessings and spiritual fulfillment."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Khatu Shyam?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Khatu Shyam travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can Salasar Balaji and Khatu Shyam be covered in the same trip?",
        answer: "Yes, customers frequently combine Khatu Shyam Temple, Salasar Balaji, and other Rajasthan religious destinations in one pilgrimage itinerary."
    },
    {
        question: "How many days are generally required for the Khatu Shyam trip?",
        answer: "The trip duration depends on the travel plan, but most devotees choose multi-day packages for a comfortable pilgrimage experience."
    },
    {
        question: "Are Tempo Travellers available for pilgrimage groups?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, religious organizations, and temple tour groups."
    },
    {
        question: "Can senior citizens travel comfortably on this route?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for elderly passengers, families, and long-distance religious travel."
    },
    {
        question: "Can I customize my temple tour itinerary?",
        answer: "Yes, customers can customize their travel schedule and include multiple temples, sightseeing locations, and accommodation stops."
    },
    {
        question: "Is advance booking recommended for Khatu Shyam Darshan?",
        answer: "Yes, advance booking is recommended, especially during festivals, Ekadashi, holidays, and peak pilgrimage seasons."
    },
    {
        question: "How can I book a Mumbai to Khatu Shyam Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mukesh Agrawal",
        feedback:
            "Our Khatu Shyam pilgrimage from Mumbai was beautifully organized. The vehicle was comfortable, the driver was experienced, and the entire journey was peaceful and enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sunita Sharma",
        feedback:
            "We traveled with our family for Khatu Shyam Darshan and received excellent service. The cab was spacious, clean, and the travel arrangements were handled professionally throughout the trip.",
        rating: 5
    }
];





















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khatu Shyam Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-khatu-shyam-cab.jpg",
  "description": "Book Mumbai to Khatu Shyam cab service for a comfortable and safe pilgrimage journey. Mumbai Airport Cabs offers reliable AC taxi service for Khatu Shyam Ji travel with professional drivers, flexible packages, and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5120"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹18,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-to-khatu-shyam-cab"
  }
};








    return (
        <div>
<Helmet>
  <title>Mumbai to Khatu Shyam Cab Service | Pilgrimage Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai to Khatu Shyam cab service for safe pilgrimage travel. AC taxi with professional drivers and flexible packages for Khatu Shyam Ji darshan."
  />

  <meta
    name="keywords"
    content="mumbai to khatu shyam cab service, khatu shyam cab service from mumbai, mumbai to khatu shyam cab package, Mumbai to Khatu Shyamji Cab, Mumbai to Khatu Shyam Mandir"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/12.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokhatushyamcab;